<script setup lang="ts">
const { t: $t } = useI18n()

const i18nHead = useLocaleHead({ addSeoAttributes: true })

useHead({
  title: () => `${$t('dhrAMzBPKaFhML2pw5inr')} - ${$t('ZtzqRdD1HHSKd7-9mLEPS')}`,
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
  meta: [
    ...(i18nHead.value.meta || []),
    { property: 'og:image', content: '/favicon.svg' },
    { name: 'description', content: () => `${$t('IuKNWe9De_k3mBKmwKv2h')}，${$t('va2l6qnwD615aEMKBU2JQ')}` },
  ],
})
</script>

<template>
  <article class="feq-root">
    <div class="feq-content page-content-width">
      <h1>{{ $t('dhrAMzBPKaFhML2pw5inr') }}</h1>
      <p>{{ $t('IuKNWe9De_k3mBKmwKv2h') }}</p>
    </div>
  </article>
</template>

<style lang="scss" scoped>
@use './style/help-content-page';
</style>
